export default __webpack_public_path__ + "static/media/ParceirosBJ.ab22aade.png";